import React from "react";

import { useTranslation } from "react-i18next";

import prettyDurations, { DURATION_UNITS } from "../../../utils/durations";
import HeaderBlock from "../HeaderBlock";

import type { JSX } from "react";

import type { PlaylistDropzoneMedia } from "../../../types/fast";

interface FASTPlaylistFormHeaderProps {
  mediaList?: PlaylistDropzoneMedia[];
}

export default function FASTPlaylistFormHeader({
  mediaList,
}: FASTPlaylistFormHeaderProps): JSX.Element {
  const { t } = useTranslation("common");

  const totalDuration =
    mediaList?.reduce((acc, curr) => acc + curr.duration, 0) ?? 0;

  const minDuration =
    mediaList?.length === 0
      ? 0
      : (mediaList?.reduce(
          (acc, curr) => Math.min(acc, curr.duration),
          Infinity,
        ) ?? 0);

  const maxDuration =
    mediaList?.reduce((acc, curr) => Math.max(acc, curr.duration), 0) ?? 0;

  return (
    <div className="flex flex-wrap gap-[0.78125rem]">
      <HeaderBlock
        blockList={[{ title: t("programs"), value: mediaList?.length ?? 0 }]}
      />
      <HeaderBlock
        blockList={[
          {
            title: t("totalDuration"),
            value:
              prettyDurations(totalDuration, {
                valueUnit: DURATION_UNITS.MILLISECONDS,
              }).humanised || 0,
          },
        ]}
      />
      <HeaderBlock
        blockList={[
          {
            title: t("minDuration"),
            value:
              prettyDurations(minDuration, {
                valueUnit: DURATION_UNITS.MILLISECONDS,
              }).humanised || 0,
          },
        ]}
      />
      <HeaderBlock
        blockList={[
          {
            title: t("maxDuration"),
            value:
              prettyDurations(maxDuration, {
                valueUnit: DURATION_UNITS.MILLISECONDS,
              }).humanised || 0,
          },
        ]}
      />
    </div>
  );
}
